<app-page-header header="information-about-journey.title.resignation" />

<qbe-panel-component>
  <app-form-element header="information-about-journey.destination.title">
    <app-dynamic-input
      [formGroup]="formGroup"
      name="destination"
      inputType="groupedSelect"
      label="information-about-journey.destination.label"
      placeholder="information-about-journey.destination.placeholder"
      [groupedOptions]="(countriesOptions$ | async) ?? []"
    ></app-dynamic-input>
  </app-form-element>
  <app-form-element header="information-about-journey.travelDates.title">
    <ng-container description>
      <p nxCopytext="normal" [innerHTML]="'information-about-journey.travelDates.description.resignation' | translate | markdown"></p>
    </ng-container>
    <app-dynamic-input
      [formGroup]="formGroup.controls.travelDates"
      name="dateFrom"
      inputType="date"
      label="information-about-journey.travelDates.dateFrom.label"
      [minDate]="minDate"
      [maxDate]="maxDate(today)"
    ></app-dynamic-input>
    <app-dynamic-input
      [formGroup]="formGroup.controls.travelDates"
      name="dateTo"
      inputType="date"
      label="information-about-journey.travelDates.dateTo.label"
      [minDate]="formGroup.controls.travelDates.controls.dateFrom.value || undefined"
      [maxDate]="maxDate(formGroup.controls.travelDates.controls.dateFrom.value)"
    ></app-dynamic-input>
    <nx-message *ngIf="isTodaySelected(formGroup.controls.travelDates.controls.dateFrom.value)" class="u-mt-md" context="info">
      {{ 'information-about-journey.travelDates.dateFrom.additionalInfo.description' | translate }}
    </nx-message>
  </app-form-element>
  <app-form-element header="information-about-journey.numberOfInsureds.title">
    <ng-container description *ngIf="isAppAgentOrTravelAgency">
      <button nxPlainButton (click)="modalService.openModal(modalType.InsuredImport)" type="button">
        {{ 'information-about-journey.numberOfInsureds.importButton' | translate }}
      </button>
    </ng-container>
    <app-dynamic-input
      [formGroup]="formGroup"
      name="numberOfInsureds"
      inputType="numberStepper"
      label="information-about-journey.numberOfInsureds.label"
    ></app-dynamic-input>
  </app-form-element>
  <app-form-element header="information-about-journey.travelCost.title" tooltip="information-about-journey.travelCost.tooltip">
    <ng-container description>
      <p nxCopytext="normal" [innerHTML]="'information-about-journey.travelCost.description.text' | translate | markdown"></p>
    </ng-container>
    <div *ngFor="let control of formGroup.controls.travelCost.controls; index as i" class="resignation-travel-purchase-date">
      <app-dynamic-input
        [formGroup]="control"
        name="travelPurchaseDate"
        class="u-mb-dynamic"
        inputType="date"
        label="information-about-journey.travelCost.travelPurchaseDate.label"
        [maxDate]="maxTravelPurchaseDate()"
      ></app-dynamic-input>
      <app-dynamic-input
        [formGroup]="control"
        name="travelCost"
        class="u-mb-dynamic"
        inputType="number"
        label="information-about-journey.travelCost.field.label"
        suffix="information-about-journey.travelCost.field.suffix"
        [errors]="formGroup.controls.travelCost.errors"
      ></app-dynamic-input>
      <button *ngIf="i > 0" nxPlainButton type="button" (click)="handleRemoveTravelCost(i)">
        <nx-icon name="trash" class="nx-margin-right-2xs"></nx-icon>{{ 'common.delete' | translate }}
      </button>
    </div>
    <button class="align-self-flex-start" nxPlainButton type="button" (click)="handleAddNewTravelCost()">
      <nx-icon name="plus" class="nx-margin-right-2xs"></nx-icon> {{ 'information-about-journey.travelCost.addNew' | translate }}
    </button>
  </app-form-element>
  <app-form-element header="information-about-journey.travelCostSum.title">
    <ng-container description>
      <p nxCopytext="normal">
        {{ 'information-about-journey.travelCostSum.description.text' | translate }}
      </p>
    </ng-container>
    <nx-formfield label="">
      <input nxInput type="text" readonly [value]="formGroup.controls.totalTravelPrice.value" />
      <span nxFormfieldPrefix>{{ 'information-about-journey.travelCostSum.value.prefix' | translate }}</span>
      <span nxFormfieldSuffix>{{ 'information-about-journey.travelCostSum.value.suffix' | translate }}</span>
    </nx-formfield>
  </app-form-element>
  <app-form-element *ngIf="!isAppAgentOrTravelAgency" header="information-about-journey.phoneNumber.title" [last]="true">
    <ng-container description>
      <p nxCopytext="normal">
        {{ 'information-about-journey.phoneNumber.description.text1' | translate }}
      </p>
      <p nxCopytext="normal">
        {{ 'information-about-journey.phoneNumber.description.text2' | translate }}
      </p>
    </ng-container>
    <app-dynamic-input
      [formGroup]="formGroup"
      name="phoneNumber"
      inputType="phoneNumber"
      label="information-about-journey.phoneNumber.label"
    ></app-dynamic-input>
  </app-form-element>
</qbe-panel-component>
